import {LOCAL_UPDATED_FORMS, LOCAL_NEW_FORMS} from "../constants/local-entity";
import {LOCAL_NEW_STATE, LOCAL_UPDATE_STATE} from "../constants/states";
import {getLocal, putLocal} from "../helpers/local-storage";
import {saveSavedForms, updateSavedForm} from "../mongo-db/saved-forms";

export const storeForm = async data => {
  if (navigator.onLine) {
    await saveSavedForms(data);
  } else {
    const localForms = getLocal(LOCAL_NEW_FORMS, []);

    const localForm = {...data, state: LOCAL_NEW_STATE};
    localForms.push(localForm);

    putLocal(LOCAL_NEW_FORMS, localForms);
  }
  return true;
};

export const updateForm = async (formId, data) => {
  if (navigator.onLine) {
    let localNewForms = getLocal(LOCAL_NEW_FORMS, []);
    let localFormsToUpdate = getLocal(LOCAL_UPDATED_FORMS, []);

    localNewForms = localNewForms.filter(f => f.IdForm !== formId);
    localFormsToUpdate = localFormsToUpdate.filter(f => f.IdForm !== formId);

    putLocal(LOCAL_NEW_FORMS, localNewForms);
    putLocal(LOCAL_UPDATED_FORMS, localFormsToUpdate);

    return await updateSavedForm(formId, data);
  } else {
    let localNewForms = getLocal(LOCAL_NEW_FORMS, []);
    let localFormsToUpdate = getLocal(LOCAL_UPDATED_FORMS, []);

    const newForm = localNewForms.find(f => f.IdForm === formId);
    const formToUpdate = localFormsToUpdate.find(f => f.IdForm === formId);
    const localForm = {...data, state: LOCAL_UPDATE_STATE};

    if (newForm) {
      localNewForms = localNewForms.filter(f => f.IdForm !== formId);
      localFormsToUpdate.push(localForm);
    } else if (formToUpdate) {
      localFormsToUpdate = localFormsToUpdate.map(f => {
        if (f.IdForm === formId) return localForm;
        return f;
      });
    } else {
      localFormsToUpdate.push(localForm);
    }

    putLocal(LOCAL_NEW_FORMS, localNewForms);
    putLocal(LOCAL_UPDATED_FORMS, localFormsToUpdate);

    return true;
  }
};
